interface UserFormValues {
  salutation: Salutations;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  passwordConfirmation: string;
  callingCode: string;
}

enum Salutations {
  MR = 'SALUTATION_MR',
  MRS = 'SALUTATION_MRS',
}

export { Salutations };
export type { UserFormValues };
